import type { Letter } from '../models/Letter';
import { formatDateTime } from '../utils/formatDate';
import styles from './LetterCard.module.css';

interface LetterCardProps {
  letter: Letter;
}

/**
 * One letter, with the name underneath as a signature.
 *
 * The heading level is h2 rather than the h3 a MemoryCard uses, because the
 * letters page has no sub-heading between the page title and the letters
 * themselves. Skipping a level would leave somebody navigating by headings
 * wondering what they had missed.
 */
export function LetterCard({ letter }: LetterCardProps) {
  const written = formatDateTime(letter.created);

  return (
    <article className={`card ${styles.card}`}>
      <p className={styles.message}>{letter.message}</p>

      <footer className={styles.signature}>
        <h2 className={styles.name}>{letter.name}</h2>
        {written ? (
          <time className={styles.date} dateTime={letter.created}>
            {written}
          </time>
        ) : null}
      </footer>
    </article>
  );
}
